import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ProductSingleContent } from './ProductSingleContent';
import { useTranslation } from 'react-i18next';
import { IProductDetails } from '../../models/ProductDetails';

import { IUserExample } from '../../resources/models/IUserExample';

interface IProps {
  product: Omit<IProductDetails, 'plans'>;
  contents: IUserExample[];
}

export const ProductContent: FC<IProps> = ({ product, contents }) => {
  const { t } = useTranslation();
  if (contents.length === 0) return null;

  return (
    <div>
      <Box marginTop={3} marginBottom={3}>
        <Typography variant={'h3'}>{t('userOverview.latestContentHeader')}</Typography>
      </Box>

      <Grid container spacing={3}>
        {contents.map((content) => {
          return <ProductSingleContent productDetails={product} userExample={content} key={content.example.zipFile} />;
        })}
      </Grid>
    </div>
  );
};
